import { Property } from './property';

export class LoadPropertyResponse {
  property: Property;
  isRedirect: boolean;
  url: string;
  ignoreValidateWorkspace: boolean;

  constructor(property: Property, isRedirect: boolean = true, url: string = null, ignoreValidateWorkspace: boolean = false) {
    this.property = property;
    this.isRedirect = isRedirect;
    this.url = url;
    this.ignoreValidateWorkspace = ignoreValidateWorkspace;
  }
}
